// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1Neo4jMajorVersion = {
  Neo4jMajorVersion4: '4',
  Neo4jMajorVersion5: '5',
  neo4jMajorVersionUnknown: 'UNKNOWN',
} as const;
export type V1Neo4jMajorVersion =
  (typeof V1Neo4jMajorVersion)[keyof typeof V1Neo4jMajorVersion];

export function instanceOfV1Neo4jMajorVersion(value: any): boolean {
  for (const key in V1Neo4jMajorVersion) {
    if (Object.prototype.hasOwnProperty.call(V1Neo4jMajorVersion, key)) {
      if (
        V1Neo4jMajorVersion[key as keyof typeof V1Neo4jMajorVersion] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1Neo4jMajorVersionFromJSON(json: any): V1Neo4jMajorVersion {
  return V1Neo4jMajorVersionFromJSONTyped(json, false);
}

export function V1Neo4jMajorVersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jMajorVersion {
  return json as V1Neo4jMajorVersion;
}

export function V1Neo4jMajorVersionToJSON(
  value?: V1Neo4jMajorVersion | null,
): any {
  return value as any;
}

export function V1Neo4jMajorVersionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1Neo4jMajorVersion {
  return value as V1Neo4jMajorVersion;
}
